
























































/**
 * 级联单选
 */

import Popup from '@/components/popup/popup.vue';
import PopupTree from '@/components/popup-tree-new.vue';
import * as tool from './../../utils/tool';
import searchIcon from '@/assets/images/search-icon.png';
import { defineComponent, ref, toRefs, computed } from '@vue/composition-api';
import teaTracker from './../../tea-tracker';
import { TEA_EVENT } from './../../const/state/TeaNames';

const name = 'tree';
export default defineComponent({
  name,
  components: {
    Popup,
    PopupTree
  },
  props: {
    title: { type: String, default: '' },
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' },
    disabled: { type: [Boolean], default: false },
    message: { type: [String], default: '' },
    hasFilter: { type: Boolean, default: false },
    dynamicHeader: { type: Boolean, default: false, required: false },
    from: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const { from } = props;
    const show = ref(false);
    const locationSearchText = ref('');
    const tempLocationOptions = ref([]);
    const { value } = toRefs(props);
    const treeNodesMap = computed(() => {
      const result = {};
      const root = { children: props.options };

      tool.walkTreeBFS({
        root,
        handler(node) {
          if (tool.isDef(node.value)) {
            result[node.value] = node;
            (node.children || []).forEach(child=> {
              child.parentId = node.value; // 父节点id
            });
          }
        }
      });
      return result;
    });
    const searchIconPath = ref(searchIcon);
    const getLabelByValue = (value): void => {
      if (!value) {
        return value;
      }
      const node = treeNodesMap.value[value];
      if (node) {
        return node.label || value;
      }
      return value;
    };
    const label = computed(() => value.value
      .map(item=> getLabelByValue(item))
      .join(' / '));


    const handleClick = () => {
      if (props.disabled) {
        return;
      }
      show.value = true;
      teaTracker.trackEvent(TEA_EVENT[`USER_CLICK_${from}_ON_TARGET`]);
      teaTracker.trackEvent(TEA_EVENT[`DISPLAY_${from}_PAGE`]);
    };
    const handleConfirm = values => {
      emit('update-tree-value', values);
      teaTracker.trackEvent(TEA_EVENT[`USER_CONFIRM_${from}`])
    };
    const handleClose = () => {
      if (props.hasFilter) {
        tempLocationOptions.value = props.options;
        locationSearchText.value = '';
      }
      show.value = false;
    };
    const handleFocusReport = () => {
      teaTracker.trackEvent(TEA_EVENT[`USER_SEARCH_ON_${from}`])
    };
    return {
      show,
      label,
      handleClick,
      treeNodesMap,
      locationSearchText,
      tempLocationOptions,
      handleFocusReport,
      handleConfirm,
      handleClose,
      searchIconPath
    };
  }
});
